/**
 * CMP Dashboard (15) "Searchable dropdown matching" (Monday EV15-74): the
 * typed text matches the start of the option; a "CODE - Name" option also
 * matches the start of the name. "an" no longer finds "Planning".
 */
export const matchesDropdownSearch = (label: string, term: string): boolean => {
  const query = term.trim().toLocaleLowerCase();
  if (!query) return true;
  const text = label.trim().toLocaleLowerCase();
  if (text.startsWith(query)) return true;
  const dash = text.indexOf(" - ");
  return dash >= 0 && text.slice(dash + 3).startsWith(query);
};
